import PDFPageViewer from './PDFPageViewer';
import SupportEmail from "../components/SupportEmail";

const HowTo = () => {
  const pdfUrl = "https://omegavoid.com/documents/Omega_Void_How_To_Use.pdf";

  return (
    <>
      <div className="howto-container" style={{marginTop:"20px"}}>
        <div className="howto-header">
          <h1>How to Use Omega Void</h1>
          <p className="howto-intro">
            Omega Void is a new kind of private messenger with no real world identifiable contacts, no threads and no retained history. Messages appear as glowing dots on a massive map —
            and then vanish forever from our servers and from your sight!
          </p>
        </div>
           <div className="video-section">
          <h2>🔗 Official Introduction Video</h2>
          <p>
            Want to see Omega Void in action? Watch our 90-second visual walkthrough explaining how
            it all works: <a href="https://www.youtube.com/watch?v=y2keY3TZW24" className="video-link">Click here to watch</a>
          </p>
        </div>

        {/* PDF Viewer Section */}
        <div className="howto-pdf-section" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
          <PDFPageViewer pdfUrl={pdfUrl} loadingText="Loading guide document..." />
        </div>

      </div>
      <SupportEmail />
    </>
  );
};

export default HowTo;
